// extracted by mini-css-extract-plugin
var _1 = "of3W6";
var _2 = "Tn7G3";
var _3 = "iJh__";
export { _1 as "base", _2 as "theme-dark", _3 as "theme-light" }
